import { render, staticRenderFns } from "./ProductsDetail.vue?vue&type=template&id=28adb208&"
import script from "./ProductsDetail.vue?vue&type=script&lang=js&"
export * from "./ProductsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDetail.vue?vue&type=style&index=0&id=28adb208&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports